import store from '@/store'
import axios from 'axios'
import router from '@/router/'

export default {
  namespaced: true,
  state: {
    motivoNoEntrega: []
  },
  mutations: {
    set_accion_motivoNoEntrega (state, motivoNoEntrega) {
      state.motivoNoEntrega = motivoNoEntrega
    }
  },
  actions: {
    async setMotivoNoEntrega ({ commit, dispatch, state }, motivoNoEntrega) {
      try {
        const response = await axios({
          method: 'post',
          // url: `https://n1ffdxatvc.execute-api.us-west-1.amazonaws.com/prod/cliente/${store.state.cliente}/equipo?marca=${store.state.marca}`,
          // url: `http://${store.state.host}/api/vps/getTransportes`,
          url: `${store.state.host}/bitacora/motivoNoEntrega/set`,
          headers: {
            Authorization: 'Bearer ' + store.state.token
          },
          data: motivoNoEntrega
        })
        if (response.status === 200) { // response - object, eg { status: 200, message: 'OK' }
          console.log('success stuff api setMotivoNoEntrega')
          console.log(response.data)
          commit('set_accion_motivoNoEntrega', response.data)
          return true
        } else {
          console.log('por else setMotivoNoEntrega')
        }
        return false
      } catch (err) {
        console.error(err)
        console.log('por catch setMotivoNoEntrega')
        router.push({ path: '/' })
        return false
      }
    }
  },
  getters: {
  }
}
